import { color } from "./color";
import SuiBox from "components/SuiBox";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import SuiTypography from "components/SuiTypography";
import ImageIcon from "@mui/icons-material/Image";
import TitleIcon from "@mui/icons-material/Title";
import HighlightAltIcon from "@mui/icons-material/HighlightAlt";
import ClothIcon from "components/Icon/ClothIcon";

import CollectionsIcon from "@mui/icons-material/Collections";
import StyleIcon from "@mui/icons-material/Style";
import PaletteIcon from "@mui/icons-material/Palette";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import PhotoAlbumIcon from "@mui/icons-material/PhotoAlbum";

export const MAX_SCREEN_WIDTH = 1670;

export const emptyImage =
  "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/178Ntdo4jMnke_svY_kGp/empty_image.png";

export const noImageaAvailable =
  "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/ueUPbhEC23qJ0aYdKBQuS/no-image-available.jpg";

export const detailAILabUrlPrefix = "/workspace/fashion-lab";

export const budgetOptions = [
  {
    label: "Less than $2,000",
    value: "0~2000",
  },
  {
    label: "$2,000 - $5,000",
    value: "2000~5000",
  },
  {
    label: "$5,000 - $10,000",
    value: "5000~10000",
  },
  {
    label: "$10,000 - $25,000",
    value: "10000~25000",
  },
  {
    label: "More than $25,000",
    value: "25000~",
  },
];

export const accountTypeOptions = [
  {
    label: "Designer",
    value: "de",
  },
  {
    label: "Manufacturer",
    value: "ma",
  },
  {
    label: "Buyer",
    value: "bu",
  },
  {
    label: "Specialist",
    value: "sp",
  },
];

export const accountStatusOptions = [
  {
    label: "Init",
    value: "init",
  },
  {
    label: "Invited",
    value: "invited",
  },
  {
    label: "Visited",
    value: "visited",
  },
  {
    label: "Active",
    value: "active",
  },
];

/*
 INIT = "init",
  REQUESTED = "requested",
  ACTIVE = "active",
  OWNER_CANCELING = "owner_canceling",
  PROVIDER_CANCELING = "provider_canceling",
  CANCELED = "canceled",
  CANCELLING="cancelling",
  CAMPLETING="completing",
  OWNER_COMPLETING = "owner_completing",
  PROVIDER_COMPLETING = "provider_completing",
  COMPLETED = "completed",
  */
export const projectStatusOptions = [
  {
    label: "Draft",
    value: "init",
  },
  {
    label: "Pending",
    value: "requested",
  },
  {
    label: "Ongoing",
    value: "active",
  },
  {
    label: "Completed",
    value: "completed",
  },
  {
    label: "Canceled",
    value: "canceled",
  },
];

export const supportingFileMap = [
  {
    stage: "Sketches/Designs",
    value: "Ideation",
    filesKey: "sketchesFiles",
  },
  {
    stage: "Tech Design",
    value: "Technical Design",
    filesKey: "techPacksFiles",
  },
  {
    stage: "Sampling",
    value: "Sampling",
    filesKey: "samplesFiles",
  },
  {
    stage: "Materials",
    value: "Sourcing",
    filesKey: "materialsFiles",
  },
  {
    stage: "Production",
    value: "Production",
    filesKey: "productionFiles",
  },
  {
    stage: "Others",
    value: "Others",
    filesKey: "othersFiles",
  },
];

export const employeeOptions = [
  {
    label: "1-10",
    value: "1-10",
  },
  {
    label: "11-50",
    value: "11-50",
  },
  {
    label: "51-200",
    value: "51-200",
  },
  {
    label: "201-500",
    value: "201-500",
  },
  {
    label: "501+",
    value: "500+",
  },
];

export const storeTypeOptions = [
  {
    label: "In-House Production",
    value: "In-House Production",
  },
  {
    label: "Factory Agent",
    value: "Factory Agent",
  },
];

export const MANUFACTURER_SERVICES = [
  {
    color: "theme1",
    icon: "lightbulb",
    label: "Design", //Ideation
    value: "Design",
    //hint: "This service includes a) researching trends, colors, silhouettes, and fabrics for the upcoming season, and b) developing garment designs and sketches.",
    hint: "This includes a) researching trends, colors, silhouettes, and fabrics, and b) developing garment designs.",
    children: [
      { label: "Research & Development", value: "Research & Development" },
      { label: "Design", value: "Design" },
      // { label: "Research & Development", value: "Research & Development" },
      // { label: "Design", value: "Design" },
    ],
  },
  /*
  {
    color: "theme4",
    icon: "design_services",
    label: "Technical Design",
    value: "Technical Design",

    children: [
      { label: "Pattern Making", value: "Pattern Making" },
      { label: "Tech Pack", value: "Tech Pack" },
      // { label: "Pattern Making", value: "Pattern Making" },
      // { label: "Tech Pack", value: "Tech Pack" },
      // { label: "Grading", value: "Grading" },
      // { label: "Marker Making", value: "Marker Making" },
    ],
  },
  */
  {
    color: "theme6",
    icon: "inventory_2",
    label: "Development", //Sampling
    value: "Development", //Sampling
    //hint: "This service overarches the multi-step process from pattern drafting, sample making, fitting, to tech pack development including spec, grading and marking. In this phrase, service provider may also guide you with final production costing process through size run/set sample making.",
    hint: "This service includes pattern drafting, sample making, fit testing, and tech pack development.",
    children: [
      // { label: "Sample Production", value: "Sample Production" },
      // { label: "Costing", value: "Costing" },
      // {
      //   label: "Quality Control & Compliance",
      //   value: "Quality Control & Compliance",
      // },
      { label: "Tech Pack", value: "Tech Pack" },
      { label: "Pattern Making", value: "Pattern Making" },
      { label: "Sample Making ", value: "Sample Making " },
      { label: "Fit Testing and Pattern Revising", value: "Fit Testing and Pattern Revising" },
      { label: "Grading and Marker Making", value: "Grading and Marker Making" },
      {
        label: "Size Run Samples & Final Production Costing",
        value: "Size Run Samples & Final Production Costing",
      },
    ],
  },
  {
    color: "theme2",
    icon: "shopping_cart",
    label: "Sourcing",
    value: "Sourcing",
    //hint: "There are two stages of fabric sourcing. One is handled before starting the make the garment pattern for sample making process. Typically, designers acquire a sample cut (2 to 6 yards) to make a sample garment for fit testing. The other fabric sourcing occurs during the development process for the production. It requires calculating all fabric yardage requirements for the whole production of the garment in various size ranges. For the accurate fabric yardage calculation, one may need the marker making process completed.",
    hint: "This includes sourcing fabric for sampling and/or production.",
    children: [
      { label: "Fabric and other materials", value: "Fabric and other materials" },
      {
        label: "Trims",
        value: "Trims",
      },
      {
        label: "Finished Garments",
        value: "Finished Garments",
      },
      // { label: "Fabric Sourcing", value: "Fabric Sourcing" },
      // { label: "Fabrics & Trims", value: "Fabrics & Trims" },
    ],
  },
  {
    color: "theme8",
    icon: "factory",
    label: "Production",
    value: "Production",
    //hint: "This service would guide you with production services from cutting to identifying and working with domestic small batch manufacturers or overseas volume production factory. It may offer you with packing, labeling, and tagging/ticketing services as well.",
    hint: "This includes identifying the production facilities either domestic or overseas.",
    children: [
      { label: "Cutting", value: "Cutting" },
      { label: "In-house Small Batch Manufacturing", value: "In-house Small Batch Manufacturing" },
      {
        label: "Specialty Manufacturing",
        value: "Specialty Manufacturing",
      },
      { label: "Off-site Volume Production", value: "Off-site Volume Production" },
      { label: "Labeling and Tagging/Ticketing", value: "Labeling and Tagging/Ticketing" },
      { label: "Screen Printing", value: "Screen Printing" },
      { label: "Garment Dyeing", value: "Garment Dyeing" },
      { label: "Embroidery", value: "Embroidery" },
      // { label: "Cutting", value: "Cutting" },
      // { label: "Mass Production", value: "Mass Production" },
      // { label: "Screen Printing", value: "Screen Printing" },
      // { label: "Labels/Packing", value: "Labels/Packing" },
      // { label: "Embroidery", value: "Embroidery" },
      // { label: "Garment Dyeing", value: "Garment Dyeing" },
    ],
  },
];

export const moqOptions = [
  {
    label: "0-300",
    value: "0-300",
  },
  {
    label: "300-1000",
    value: "300-1000",
  },
  {
    label: "1000+",
    value: "1000+",
  },
];

export const maCatOptions = [
  { label: "ACCESSORIES", value: "ACCESSORIES" },
  { label: "ACTIVEWEAR", value: "ACTIVEWEAR" },
  { label: "BRIDALWEAR", value: "BRIDALWEAR" },
  { label: "WOMEN'S WEAR", value: "WOMEN'S WEAR" },
  { label: "MEN'S WEAR", value: "MEN'S WEAR" },
  { label: "CHILDREN'S WEAR", value: "CHILDREN'S WEAR" },
  { label: "DRESSES", value: "DRESSES" },
  { label: "HEADWEAR", value: "HEADWEAR" },
  { label: "INTIMATES & SHAPEWEAR", value: "INTIMATES & SHAPEWEAR" },
  { label: "JEANS", value: "JEANS" },
  { label: "JUMPSUITS & ROMPERS", value: "JUMPSUITS & ROMPERS" },
  { label: "LEATHER GOODS", value: "LEATHER GOODS" },
  { label: "MATERNITY", value: "MATERNITY" },
  { label: "OUTERWEAR", value: "OUTERWEAR" },
  { label: "PAJAMAS & LOUNGEWEAR", value: "PAJAMAS & LOUNGEWEAR" },
  { label: "PANTS/SHORTS", value: "PANTS/SHORTS" },
  { label: "PRINTED TEES", value: "PRINTED TEES" },
  { label: "SHIRTS/BLOUSES/POLOS", value: "SHIRTS/BLOUSES/POLOS" },
  { label: "SOCKS & HOSIERY", value: "SOCKS & HOSIERY" },
  { label: "SUITS & BLAZERS", value: "SUITS & BLAZERS" },
  { label: "SWEATER", value: "SWEATER" },
  { label: "SWEATSHIRTS & HOODIES & Joggers", value: "SWEATSHIRTS & HOODIES & Joggers" },
  { label: "SWIMWEAR", value: "SWIMWEAR" },
  { label: "UNIFORMS", value: "UNIFORMS" },
];

export const storeTags = [
  { label: "BEGINNERS", value: "BEGINNERS" },
  { label: "SMALL BUSINESSES", value: "SMALL BUSINESSES" },
  { label: "BIG BRANDS", value: "BIG BRANDS" },
  { label: "SUSTAINABLE", value: "SUSTAINABLE" },
  { label: "ECO-FRIENDLY", value: "ECO-FRIENDLY" },
  { label: "GRADING", value: "GRADING" },
  { label: "NO MINIMUM", value: "NO MINIMUM" },
  { label: "PRIVATE LABEL", value: "PRIVATE LABEL" },
  { label: "MADE IN USA", value: "MADE IN USA" },
  { label: "SMALL BATCH", value: "SMALL BATCH" },
  { label: "LARGE BATCH", value: "LARGE BATCH" },
  { label: "WOMEN OWNED", value: "WOMEN OWNED" },
  { label: "MINORITY OWNED", value: "MINORITY OWNED" },
  {
    label: "ETHICAL WORKING CONDITIONS",
    value: "ETHICAL WORKING CONDITIONS",
  },
  { label: "COMPETITIVE WAGES", value: "COMPETITIVE WAGES" },
  { label: "INTERNATIONAL", value: "INTERNATIONAL" },
];

export const sizeOptions = [
  { label: "XXS", value: "XXS" },
  { label: "XS", value: "XS" },
  { label: "S", value: "S" },
  { label: "M", value: "M" },
  { label: "L", value: "L" },
  { label: "XL", value: "XL" },
  { label: "XXL", value: "XXL" },
  { label: "OTHER", value: "OTHER" },
];

export const projectSortOptions = [
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Update Time</SuiBox>
        <ArrowDownwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "-updated_at",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Update Time</SuiBox>
        <ArrowUpwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "updated_at",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Status</SuiBox>
        <ArrowDownwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "-status",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Status</SuiBox>
        <ArrowUpwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "status",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Name</SuiBox>
        <ArrowDownwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "-name",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Name</SuiBox>
        <ArrowUpwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "name",
  },
];

export const projectRequestsSortOptions = [
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Update Time</SuiBox>
        <ArrowDownwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "-updated_at",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Update Time</SuiBox>
        <ArrowUpwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "updated_at",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Create Time</SuiBox>
        <ArrowDownwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "-created_at",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Create Time</SuiBox>
        <ArrowUpwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "created_at",
  },
];

export const stylesSortOptions = [
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Update Time</SuiBox>
        <ArrowDownwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "-updated_at",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Update Time</SuiBox>
        <ArrowUpwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "updated_at",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Create Time</SuiBox>
        <ArrowDownwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "-created_at",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Create Time</SuiBox>
        <ArrowUpwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "created_at",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Name</SuiBox>
        <ArrowDownwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "-title",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Name</SuiBox>
        <ArrowUpwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "title",
  },
];

export const collectionSortOptions = [
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Season</SuiBox>
        <ArrowDownwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "-season",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Season</SuiBox>
        <ArrowUpwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "season",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Year</SuiBox>
        <ArrowDownwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "-year",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Year</SuiBox>
        <ArrowUpwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "year",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Update Time</SuiBox>
        <ArrowDownwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "-updated_at",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Update Time</SuiBox>
        <ArrowUpwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "updated_at",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Name</SuiBox>
        <ArrowDownwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "-title",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Name</SuiBox>
        <ArrowUpwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "title",
  },
];

export const moodboardSortOptions = [
  {
    label: <>Update Time &#8595;</>, //arrow down
    value: "-updated_at",
  },
  {
    label: <>Update Time &#8593;</>, //arrow up
    value: "updated_at",
  },
  {
    label: <>Create Time &#8595;</>, //arrow down
    value: "-created_at",
  },
  {
    label: <>Create Time &#8593;</>, //arrow up,
    value: "created_at",
  },
  {
    label: <>Name &#8595;</>, //arrow down
    value: "-name",
  },
  {
    label: <>Name &#8593;</>, //arrow up
    value: "name",
  },
];

export const postSortOptions = [
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Published Time</SuiBox>
        <ArrowDownwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "-published_at",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Published Time</SuiBox>
        <ArrowUpwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "published_at",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Likes</SuiBox>
        <ArrowDownwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "-like_amount",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Likes</SuiBox>
        <ArrowUpwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "like_amount",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Views</SuiBox>
        <ArrowDownwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "-page_view",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Views</SuiBox>
        <ArrowUpwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "page_view",
  },
];

export const postDBSortOptions = [
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Created Time</SuiBox>
        <ArrowDownwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "-created_at",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Created Time</SuiBox>
        <ArrowUpwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "created_at",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Updated</SuiBox>
        <ArrowDownwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "-updated_at",
  },
  {
    label: (
      <SuiBox display="flex" alignItems="center" gap={1} sx={{ whiteSpace: "nowrap" }}>
        <SuiBox>Updated</SuiBox>
        <ArrowUpwardIcon fontSize="sm" />
      </SuiBox>
    ),
    value: "updated_at",
  },
];

export const externalLinks =
  window.location.hostname == "dev2.upstyled.co"
    ? {
        "privacy-policy": "https://www.upstyled.co/privacy-policy",
        "terms-of-service": "https://www.upstyled.co/terms-of-service",
        "about-us": "https://www.upstyled.co",
        help: "https://devhelp.upstyled.co",
      }
    : {
        "privacy-policy": "https://www.upstyled.co/privacy-policy",
        "terms-of-service": "https://www.upstyled.co/terms-of-service",
        "about-us": "https://www.upstyled.co",
        help: "https://help.upstyled.co",
      };

export const seasonOptions = [
  {
    label: "Spring",
    value: "spring",
  },
  {
    label: "Summer",
    value: "summer",
  },
  {
    label: "Fall",
    value: "fall",
  },
  {
    label: "Winter",
    value: "winter",
  },
  {
    label: "Spring/Summer",
    value: "spring/summer",
  },
  {
    label: "Fall/Winter",
    value: "fall/winter",
  },
  {
    label: "Resort",
    value: "resort",
  },
  {
    label: "Pre-Fall",
    value: "pre-fall",
  },
  {
    label: "All Season",
    value: "all",
  },
];

export const privilegeOptions = [
  {
    label: "Viewer", //can leave comments
    value: 1,
  },
  {
    label: "Editor",
    value: 2,
  },
  {
    label: "Remove Access",
    value: 0,
  },
];

export const sizeChartOptions = [
  {
    label: "Mens",
    value: "Mens",
    type: {
      class: [
        {
          label: "Regular",
          value: "Regular",
        },
        {
          label: "Petite",
          value: "Petite",
        },
        {
          label: "Tall",
          value: "Tall",
        },
      ],
      category: [
        {
          label: "Clothing",
          value: "Clothing",
          children: [
            { label: "Activewear", value: "Activewear" },
            { label: "Blazers & Sports Coats", value: "Blazers & Sports Coats" },
            { label: "Coats & Jackets", value: "Coats & Jackets" },
            { label: "Dress Shirts", value: "Dress Shirts" },
            { label: "Jeans", value: "Jeans" },
            { label: "Loungewear, Pajamas & Robes", value: "Loungewear, Pajamas & Robes" },
            { label: "Pants", value: "Pants" },
            { label: "Polo Shirts", value: "Polo Shirts" },
            { label: "Shirts", value: "Shirts" },
            { label: "Suits & Separates", value: "Suits & Separates" },
            { label: "Sweaters", value: "Sweaters" },
            { label: "Sweatshirts & Hoodies", value: "Sweatshirts & Hoodies" },
            { label: "T-Shirts", value: "T-Shirts" },
            { label: "Underwear, Undershirts & Socks", value: "Underwear, Undershirts & Socks" },
          ],
        },
      ],
    },
  },
  {
    label: "Womens",
    value: "Womens",
    type: {
      class: [
        {
          label: "Regular",
          value: "Regular",
        },
        {
          label: "Petite",
          value: "Petite",
        },
        {
          label: "Tall",
          value: "Tall",
        },
      ],
      category: [
        {
          label: "Clothing",
          value: "Clothing",
          children: [
            { label: "Activewear", value: "Activewear" },
            { label: "Blouses & Shirts", value: "Blouses & Shirts" },
            { label: "Blazers, Suits & Separates", value: "Blazers, Suits & Separates" },
            { label: "Coats & Jackets", value: "Coats & Jackets" },
            { label: "Dresses", value: "Dresses" },
            { label: "Jeans & Denim", value: "Jeans & Denim" },
            { label: "Jumpsuits & Rompers", value: "Jumpsuits & Rompers" },
            { label: "Lingerie, Hosiery & Shapewear", value: "Lingerie, Hosiery & Shapewear" },
            { label: "Loungewear", value: "Loungewear" },
            { label: "Pants & Leggings", value: "Pants & Leggings" },
            { label: "Skirts", value: "Skirts" },
            { label: "Sleepwear & Robes", value: "Sleepwear & Robes" },
            { label: "Sweaters", value: "Sweaters" },
            { label: "Sweatshirts & Hoodies", value: "Sweatshirts & Hoodies" },
            { label: "Swimsuits & Coverups", value: "Swimsuits & Coverups" },
            { label: "Tops", value: "Tops" },
          ],
        },
      ],
    },
  },
];

export const colorOptions = [
  // { label: "blue", value: "#abe9f7" },
  // { label: "red", value: "#fc9797" },
  // { label: "green", value: "#cdf59b" },
  // { label: "violet", value: "#f883dd" },
  // { label: "gray", value: "#e4e8ed" },
  // { label: "orange", value: "#fef5d3" },
  // { label: "light", value: "#c7d3de" },
  { label: "red", value: "#db4437" },
  { label: "orange", value: "#f4b400" },
  { label: "yellow", value: "#ffce44" },
  { label: "green", value: "#009688" },
  { label: "teal", value: "#0c8599" },
  { label: "blue", value: "#4285f4" },
  { label: "purple", value: "#7b1fa2" },
  { label: "pink", value: "#e67c73" },
  { label: "gray", value: "#616161" },
  { label: "brown", value: "#a0522d" },
];

export const roleTags = [
  // "buyer",
  // "designer",
  "influencer",
  "journalist",
  "marketing manager",
  "merchandiser",
  "model",
  "photographer",
  "stylist",
  "textile designer",
  "trend forecaster",
  "educator",
  "pattern maker",
  "quality control inspector",
  "sourcing agent",
];

export const resourceCategoryOptions = [
  { label: "Jacket/Coat", value: "jacket/coat" },
  { label: "Top", value: "top" },
  { label: "Bottom", value: "bottom" },
  { label: "Dress/Romper", value: "dress/romper" },
  {
    label: "Detail",
    value: "detail",
  },
];

export const resourceDetailSketchOptions = [
  { label: "Neckline", value: "neckline" },
  { label: "Collar", value: "collar" },
  { label: "Lapel", value: "lapel" },
  { label: "Sleeve", value: "sleeve" },
  { label: "Cuff", value: "cuff" },
  { label: "Opening", value: "opening" },
  { label: "Pocket", value: "pocket" },
  // { label: "Jacket Detail", value: "jacket-detail" },
  { label: "Shirt Detail", value: "shirt-detail" },
  { label: "Pants Detail", value: "pants-detail" },
  { label: "Jeans Detail", value: "jeans-detail" },
];

export const resourceTypeOptions = [
  { label: "Internal", value: "internal" },
  { label: "Flat Sketch", value: "flat_sketch" },
];

export const promptTags = [
  {
    label: "gender",
    value: "gender",
    children: [
      { label: "man", value: "man" },
      { label: "woman", value: "woman" },
      { label: "non-binary", value: "Non-binary gender" },
    ],
  },
  {
    label: "categories",
    value: "categories",
    children: [
      { label: "blazer", value: "blazer" },
      { label: "blouse", value: "blouse" },
      { label: "bodysuit", value: "bodysuit" },
      { label: "button-down shirt", value: "button-down shirt" },
      { label: "cardigan", value: "cardigan" },
      { label: "chinos", value: "chinos" },
      { label: "coat", value: "coat" },
      { label: "crop top", value: "crop top" },
      { label: "dress", value: "dress" },
      { label: "halter top", value: "halter top" },
      { label: "hoodie", value: "hoodie" },
      { label: "jacket", value: "jacket" },
      { label: "jeans", value: "jeans" },
      { label: "jumpsuit", value: "jumpsuit" },
      { label: "kimono", value: "kimono" },
      { label: "overalls", value: "overalls" },
      { label: "polo shirt", value: "polo shirt" },
      { label: "poncho", value: "poncho" },
      { label: "romper", value: "romper" },
      //{ label: "shawl", value: "shawl" },
      { label: "shirt", value: "shirt" },
      { label: "shorts", value: "shorts" },
      { label: "skirt", value: "skirt" },
      { label: "suit", value: "suit" },
      { label: "sweater", value: "sweater" },
      { label: "sweatpants", value: "sweatpants" },
      { label: "sweatshirt", value: "sweatshirt" },
      { label: "t-shirt", value: "t-shirt" },
      { label: "tank top", value: "tank top" },
      { label: "tights", value: "tights" },
      { label: "trousers", value: "trousers" },
      { label: "tunic", value: "tunic" },
      { label: "tuxedo", value: "tuxedo" },
      { label: "vest", value: "vest" },
    ],
  },
  {
    label: "style",
    value: "style",
    children: [
      { label: "athleisure", value: "athleisure style" },
      { label: "avant-garde", value: "avant-garde style" },
      { label: "bohemian", value: "bohemian style" },
      { label: "business", value: "business style" },
      { label: "casual", value: "casual style" },
      { label: "classic", value: "classic style" },
      { label: "country", value: "country style" },
      { label: "cosplay", value: "cosplay style" },

      { label: "edgy", value: "edgy style" },
      { label: "formal", value: "formal style" },
      { label: "futuristic", value: "futuristic style" },

      { label: "gothic", value: "gothic style" },
      { label: "grunge", value: "grunge style" },
      { label: "hipster", value: "hipster style" },
      { label: "lolita", value: "lolita style" },
      { label: "maxi", value: "maxi style" },
      { label: "military", value: "military style" },
      { label: "minimalistic", value: "minimalistic style" },
      { label: "modern", value: "modern style" },
      { label: "preppy", value: "preppy style" },
      { label: "punk", value: "punk style" },
      { label: "safari", value: "safari style" },
      { label: "sporty", value: "sporty style" },
      { label: "streetwear", value: "streetwear style" },
      { label: "thrift", value: "thrift style" },

      { label: "vintage", value: "vintage style" },
      { label: "urban", value: "urban style" },

      { label: "western", value: "western style" },
    ],
  },
  {
    label: "material",
    value: "material",
    children: [
      { label: "cashmere", value: "cashmere material" },
      { label: "corduroy", value: "corduroy material" },
      { label: "cotton", value: "cotton material" },
      { label: "denim", value: "denim material" },
      { label: "faux fur", value: "faux fur material" },
      { label: "feather", value: "feather material" },
      { label: "flannel", value: "flannel material" },
      { label: "hemp", value: "hemp material" },
      { label: "lace", value: "lace material" },
      { label: "leather", value: "leather material" },
      { label: "linen", value: "linen material" },
      { label: "mesh", value: "mesh material" },
      { label: "nylon", value: "nylon material" },
      { label: "polyester", value: "polyester material" },
      { label: "satin", value: "satin material" },
      { label: "silk", value: "silk material" },
      { label: "suede", value: "suede material" },
      { label: "tulle", value: "tulle material" },

      { label: "tweed", value: "tweed material" },
      { label: "velvet", value: "velvet material" },
      { label: "wool", value: "wool material" },
    ],
  },
  {
    label: "color",
    value: "color",
    children: [
      { label: "beige", value: "beige color" },
      { label: "black", value: "black color" },
      { label: "blue", value: "blue color" },
      { label: "bronze", value: "bronze color" },
      { label: "brown", value: "brown color" },
      { label: "burgundy", value: "burgundy color" },
      { label: "charcoal", value: "charcoal color" },
      { label: "gold", value: "gold color" },
      { label: "gray", value: "gray color" },
      { label: "green", value: "green color" },
      { label: "khaki", value: "khaki color" },
      { label: "navy blue", value: "navy blue color" },
      { label: "olive green", value: "olive green color" },
      { label: "orange", value: "orange color" },
      { label: "pink", value: "pink color" },
      { label: "purple", value: "purple color" },
      { label: "red", value: "red color" },
      { label: "silver", value: "silver color" },
      { label: "white", value: "white color" },
      { label: "yellow", value: "yellow color" },
    ],
  },
  {
    label: "pattern",
    value: "pattern",
    children: [
      {
        label: "animal print",
        value: "animal print pattern design",
      },
      { label: "argyle", value: "argyle pattern design" },
      { label: "cable knit", value: "cable knit pattern design" },
      {
        label: "checkered",
        value: "checkered pattern design",
      },
      { label: "chevron", value: "chevron pattern design" },
      { label: "damask", value: "damask pattern design" },
      { label: "fine knit", value: "fine knit pattern design" },

      { label: "floral", value: "floral pattern design" },
      { label: "gingham", value: "gingham pattern design" },
      {
        label: "houndstooth",
        value: "houndstooth pattern design",
      },
      { label: "paisley", value: "paisley pattern design" },
      { label: "plaid", value: "plaid pattern design" },
      {
        label: "polka-dot",
        value: "polka-dot pattern design",
      },
      { label: "striped", value: "striped pattern design" },
      { label: "sweater knit", value: "sweater knit pattern design" },

      { label: "tie-dye", value: "tie-dye pattern design" },
    ],
  },
  {
    label: "fit",
    value: "fit",
    children: [
      { label: "athletic", value: "athletic fit" },
      { label: "cinched", value: "cinched fit" },
      { label: "clingy", value: "clingy fit" },
      { label: "draped", value: "draped fit" },
      { label: "fitted", value: "fitted fit" },
      { label: "flared", value: "flared fit" },
      { label: "flouncy", value: "flouncy fit" },
      { label: "loose", value: "loose fit" },
      { label: "oversized", value: "oversized fit" },
      { label: "regular", value: "regular fit" },
      { label: "relaxed", value: "relaxed fit" },
      { label: "roomy", value: "roomy fit" },
      { label: "semi-fitted", value: "semi-fitted fit" },
      { label: "skinny", value: "skinny fit" },
      { label: "slim", value: "slim fit" },
      { label: "snug", value: "snug fit" },
      { label: "straight", value: "straight fit" },
      { label: "tailored", value: "tailored fit" },
      { label: "tapered", value: "tapered fit" },
      { label: "trim", value: "trim fit" },
    ],
  },
  {
    label: "closure",
    value: "closure",
    children: [
      { label: "buckle", value: "buckle closure" },
      { label: "button", value: "button closure" },
      { label: "clasp", value: "clasp closure" },
      { label: "corset", value: "corset closure" },
      { label: "drawstring", value: "drawstring closure" },
      { label: "hook-and-eye", value: "hook-and-eye closure" },
      { label: "lace-up", value: "lace-up closure" },
      { label: "tie", value: "tie closure" },
      { label: "velcro", value: "velcro closure" },
      { label: "wrap", value: "wrap closure" },
      { label: "zipper", value: "zipper closure" },
    ],
  },
  {
    label: "collar",
    value: "collar",
    children: [
      { label: "band", value: "band collar" },
      { label: "bertha", value: "bertha collar" },
      { label: "bow", value: "bow collar" },
      { label: "collarless", value: "collarless collar" },
      { label: "cutaway", value: "cutaway collar" },
      { label: "lapel", value: "lapel collar" },
      { label: "mandarin", value: "mandarin collar" },
      { label: "notched", value: "notched collar" },
      { label: "peter pan", value: "peter pan collar" },
      { label: "round neck", value: "round neck collar" },
      { label: "ruffled", value: "ruffled collar" },
      { label: "shawl", value: "shawl collar" },
      { label: "square", value: "square collar" },
      { label: "stand", value: "stand collar" },
      { label: "turtleneck", value: "turtleneck collar" },
      { label: "v-neck", value: "v-neck collar" },
    ],
  },
  {
    label: "sleeve style",
    value: "sleeve style",
    children: [
      { label: "3/4", value: "3/4 sleeve" },
      { label: "bell", value: "bell sleeves" },
      { label: "bishop", value: "bishop sleeves" },
      { label: "butterfly", value: "butterfly sleeves" },
      { label: "cap", value: "cap sleeves" },
      { label: "dolman", value: "dolman sleeves" },
      { label: "half", value: "half sleeve" },
      { label: "kimono", value: "kimono sleeves" },
      { label: "long", value: "long sleeve" },
      { label: "off-shoulder", value: "off-shoulder" },
      { label: "puff", value: "puff sleeves" },
      { label: "raglan", value: "raglan sleeves" },
      { label: "short", value: "short sleeve" },
      { label: "sleeveless", value: "sleeveless" },
    ],
  },
  {
    label: "waistline",
    value: "waistline",
    children: [
      { label: "basque", value: "basque waistline" },
      { label: "belted", value: "belted waistline" },
      { label: "cinched", value: "cinched waistline" },
      { label: "corseted", value: "corseted waistline" },
      { label: "cut-out", value: "cut-out waistline" },
      { label: "drop", value: "drop waistline" },
      { label: "elastic", value: "elastic waistline" },
      { label: "empire", value: "empire waistline" },

      { label: "high", value: "high waistline" },
      { label: "low", value: "low waistline" },
      { label: "natural", value: "natural waistline" },
      { label: "peau de soie", value: "peau de soie waistline" },
      { label: "peplum", value: "peplum waistline" },
    ],
  },
  {
    label: "neckline",
    value: "neckline",
    children: [
      { label: "asymmetrical", value: "asymmetrical neckline" },
      { label: "bandeau", value: "bandeau neckline" },
      { label: "boat", value: "boat neckline" },
      { label: "choker", value: "choker neckline" },
      { label: "cowl", value: "cowl neckline" },
      { label: "halter", value: "halter neckline" },
      { label: "plunge", value: "plunge neckline" },
      { label: "scoop", value: "scoop neckline" },
      { label: "square", value: "square neckline" },
      { label: "sweetheart", value: "sweetheart neckline" },
      { label: "u-neck", value: "u-neck neckline" },
      { label: "v-neck", value: "v-neck neckline" },
      { label: "v-back", value: "v-back neckline" },
    ],
  },
  {
    label: "hemline",
    value: "hemline",
    children: [
      { label: "flared", value: "flared hemline" },
      { label: "floor length", value: "floor length hemline" },
      {
        label: "high-low length",
        value: "high-low length hemline",
      },
      { label: "knee length", value: "knee length hemline" },
      { label: "layered", value: "layered hemline" },
      { label: "midi length", value: "midi length hemline" },
      { label: "mini length", value: "mini length hemline" },
      { label: "pleated", value: "pleated hemline" },
      { label: "scalloped", value: "scalloped hemline" },
      { label: "straight", value: "straight hemline" },
      { label: "tiered", value: "tiered hemline" },
    ],
  },
  {
    label: "size",
    value: "size",
    children: [
      { label: "athletic", value: "athletic size" },
      { label: "petite", value: "petite size" },

      { label: "plus", value: "plus size" },
      { label: "regular", value: "regular size" },
      { label: "slim", value: "slim size" },
    ],
  },
  {
    label: "background",
    value: "background",
    children: [
      {
        value: "white background",
        label: "White",
        img: "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/Tc7Ti-lkoZkqkts_WA_od/white.jpg",
      },
      {
        value: "street background",
        label: "Street",
        img: "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/Tc7Ti-lkoZkqkts_WA_od/street.jpeg",
      },
      {
        value: "park background",
        label: "Park",
        img: "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/Tc7Ti-lkoZkqkts_WA_od/park.jpg",
      },
      {
        value: "beach background",
        label: "Beach",
        img: "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/6O7rsotbVx64OudmnQ84L/beach.jpeg",
      },
    ],
  },
  // {
  //   label: "brands",
  //   value: "brands",
  //   children: [
  //     { label: "alexander mcQueen", value: "alexander mcQueen" },
  //     { label: "alexander wang", value: "alexander wang" },
  //     { label: "armani", value: "armani" },
  //     { label: "azzedine alaïa", value: "azzedine alaïa" },
  //     { label: "balenciaga", value: "balenciaga" },
  //     { label: "balmain", value: "balmain" },
  //     { label: "bottega veneta", value: "bottega veneta" },
  //     { label: "burberry", value: "burberry" },
  //     { label: "calvin klein", value: "calvin klein" },
  //     { label: "carolina herrera", value: "carolina herrera" },
  //     { label: "celine", value: "celine" },
  //     { label: "chloé", value: "chloé" },
  //     { label: "christian louboutin", value: "christian louboutin" },
  //     { label: "dior", value: "dior" },
  //     { label: "dior", value: "dior" },
  //     { label: "dolce & gabbana", value: "dolce & gabbana" },
  //     { label: "elie saab", value: "elie saab" },
  //     { label: "emilio pucci", value: "emilio pucci" },
  //     { label: "ermenegildo zegna", value: "ermenegildo zegna" },
  //     { label: "escada", value: "escada" },
  //     { label: "etro", value: "etro" },
  //     { label: "fendi", value: "fendi" },
  //     { label: "giambattista valli", value: "giambattista valli" },
  //     { label: "givenchy", value: "givenchy" },
  //     { label: "gucci", value: "gucci" },
  //     { label: "hermès", value: "hermès" },
  //     { label: "hugo boss", value: "hugo boss" },
  //     { label: "jean paul gaultier", value: "jean paul gaultier" },
  //     { label: "jimmy choo", value: "jimmy choo" },
  //     { label: "kenzo", value: "kenzo" },
  //     { label: "louis vuitton", value: "louis vuitton" },
  //     { label: "mark jacobs", value: "mark jacobs" },
  //     { label: "max mara", value: "max mara" },
  //     { label: "michael kors", value: "michael kors" },
  //     { label: "miu miu", value: "miu miu" },
  //     { label: "moschino", value: "moschino" },
  //     { label: "oscar de la renta", value: "oscar de la renta" },
  //     { label: "prada", value: "prada" },
  //     { label: "proenza schouler", value: "proenza schouler" },
  //     { label: "ralph lauren", value: "ralph lauren" },
  //     { label: "roberto cavalli", value: "roberto cavalli" },
  //     { label: "saint laurent", value: "saint laurent" },
  //     { label: "stella mcCartney", value: "stella mcCartney" },
  //     { label: "tom ford", value: "tom ford" },
  //     { label: "valentino", value: "valentino" },
  //     { label: "versace", value: "versace" },
  //     { label: "vivienne westwood", value: "vivienne westwood" },
  //     { label: "zac posen", value: "zac posen" },
  //   ],
  // },
];

export const modelMap = [
  {
    label: "Text-to-Image",
    value: "gen.flat.sd",
    icon: <TitleIcon fontSize="medium" />,
  },
  {
    label: "Local Refinement", //"Local Refinement",
    value: "gen.flat.inpaint", //inpaint
    icon: <HighlightAltIcon fontSize="medium" />,
  },
  {
    label: "Image Variations",
    value: "gen.flat",
    icon: <ImageIcon fontSize="medium" />,
  },

  // {
  //   label: "Sketch & Fabric",
  //   value: "fabric",
  //   icon: <ClothIcon fontSize="medium" />,
  // },
];

export const materialCategoryOptions = [
  {
    label: "Fabric",
    value: "fabric",
  },
  {
    label: "Trim",
    value: "trim",
  },
  {
    label: "Hardware",
    value: "hardware",
  },
  {
    label: "Others",
    value: "others",
  },
];

export const uwProductCrownShapeOptions = [
  {
    label: "Five Panel High",
    value: "5S",
  },
  {
    label: "Six Panel High",
    value: "6H",
  },
  {
    label: "Five Panel Low",
    value: "5L",
  },
  {
    label: "Lowstyle",
    value: "6L",
  },
  {
    label: "Prostyle",
    value: "6S",
  },
  {
    label: "Unstructured",
    value: "6U",
  },
  {
    label: "Five Panel Camper",
    value: "5C", //unknown code
  },
  {
    label: "Sun Visor",
    value: "6V", //unknown code
  },
];

export const uwProductClosureTypeOptions = [
  {
    label: "Polo Strap",
    value: "T",
  },
  {
    label: "Leather Strap",
    value: "L",
  },
  {
    label: "Plastic Strap",
    value: "P",
  },
  {
    label: "Stretchfit Back",
    value: "E",
  },
  {
    label: "Fabric Strap",
    value: "F",
  },
  {
    label: "Velcro Strap",
    value: "V",
  },
  {
    label: "Webbing",
    value: "W",
  },
];
export const uwProductVisorOptions = [
  {
    label: "Curved",
    value: "curved",
  },
  {
    label: "Flat",
    value: "flat",
  },
];

export const materialLibraryDefaultTableHeader = [
  {
    field: "price",
    headerName: "Price/unit($)",
  },
  {
    field: "supplier",
    headerName: "Supplier",
  },
  {
    field: "color",
    headerName: "Color",
  },
  {
    field: "url",
    headerName: "URL",
  },
];

export const usaStates = [
  {
    name: "Alabama",
    abbreviation: "AL",
    territory: false,
    capital: "Montgomery",
    contiguous: true,
  },
  {
    name: "Alaska",
    abbreviation: "AK",
    territory: false,
    capital: "Juneau",
    contiguous: false,
  },
  {
    name: "American Samoa",
    abbreviation: "AS",
    territory: true,
    capital: "Pago Pago",
    contiguous: false,
  },
  {
    name: "Arizona",
    abbreviation: "AZ",
    territory: false,
    capital: "Phoenix",
    contiguous: true,
  },
  {
    name: "Arkansas",
    abbreviation: "AR",
    territory: false,
    capital: "Little Rock",
    contiguous: true,
  },
  {
    name: "California",
    abbreviation: "CA",
    territory: false,
    capital: "Sacramento",
    contiguous: true,
  },
  {
    name: "Colorado",
    abbreviation: "CO",
    territory: false,
    capital: "Denver",
    contiguous: true,
  },
  {
    name: "Connecticut",
    abbreviation: "CT",
    territory: false,
    capital: "Hartford",
    contiguous: true,
  },
  {
    name: "Delaware",
    abbreviation: "DE",
    territory: false,
    capital: "Dover",
    contiguous: true,
  },
  {
    name: "District Of Columbia",
    abbreviation: "DC",
    territory: false,
    capital: "",
    contiguous: true,
  },
  {
    name: "Federated States Of Micronesia",
    abbreviation: "FM",
    territory: true,
    capital: "Palikir",
    contiguous: false,
  },
  {
    name: "Florida",
    abbreviation: "FL",
    territory: false,
    capital: "Tallahassee",
    contiguous: true,
  },
  {
    name: "Georgia",
    abbreviation: "GA",
    territory: false,
    capital: "Atlanta",
    contiguous: true,
  },
  {
    name: "Guam",
    abbreviation: "GU",
    territory: true,
    capital: "Hagåtña",
    contiguous: false,
  },
  {
    name: "Hawaii",
    abbreviation: "HI",
    territory: false,
    capital: "Honolulu",
    contiguous: false,
  },
  {
    name: "Idaho",
    abbreviation: "ID",
    territory: false,
    capital: "Boise",
    contiguous: true,
  },
  {
    name: "Illinois",
    abbreviation: "IL",
    territory: false,
    capital: "Springfield",
    contiguous: true,
  },
  {
    name: "Indiana",
    abbreviation: "IN",
    territory: false,
    capital: "Indianapolis",
    contiguous: true,
  },
  {
    name: "Iowa",
    abbreviation: "IA",
    territory: false,
    capital: "Des Moines",
    contiguous: true,
  },
  {
    name: "Kansas",
    abbreviation: "KS",
    territory: false,
    capital: "Topeka",
    contiguous: true,
  },
  {
    name: "Kentucky",
    abbreviation: "KY",
    territory: false,
    capital: "Frankfort",
    contiguous: true,
  },
  {
    name: "Louisiana",
    abbreviation: "LA",
    territory: false,
    capital: "Baton Rouge",
    contiguous: true,
  },
  {
    name: "Maine",
    abbreviation: "ME",
    territory: false,
    capital: "Augusta",
    contiguous: true,
  },
  {
    name: "Marshall Islands",
    abbreviation: "MH",
    territory: true,
    capital: "Majuro",
    contiguous: false,
  },
  {
    name: "Maryland",
    abbreviation: "MD",
    territory: false,
    capital: "Annapolis",
    contiguous: true,
  },
  {
    name: "Massachusetts",
    abbreviation: "MA",
    territory: false,
    capital: "Boston",
    contiguous: true,
  },
  {
    name: "Michigan",
    abbreviation: "MI",
    territory: false,
    capital: "Lansing",
    contiguous: true,
  },
  {
    name: "Minnesota",
    abbreviation: "MN",
    territory: false,
    capital: "Saint Paul",
    contiguous: true,
  },
  {
    name: "Mississippi",
    abbreviation: "MS",
    territory: false,
    capital: "Jackson",
    contiguous: true,
  },
  {
    name: "Missouri",
    abbreviation: "MO",
    territory: false,
    capital: "Jefferson City",
    contiguous: true,
  },
  {
    name: "Montana",
    abbreviation: "MT",
    territory: false,
    capital: "Helena",
    contiguous: true,
  },
  {
    name: "Nebraska",
    abbreviation: "NE",
    territory: false,
    capital: "Lincoln",
    contiguous: true,
  },
  {
    name: "Nevada",
    abbreviation: "NV",
    territory: false,
    capital: "Carson City",
    contiguous: true,
  },
  {
    name: "New Hampshire",
    abbreviation: "NH",
    territory: false,
    capital: "Concord",
    contiguous: true,
  },
  {
    name: "New Jersey",
    abbreviation: "NJ",
    territory: false,
    capital: "Trenton",
    contiguous: true,
  },
  {
    name: "New Mexico",
    abbreviation: "NM",
    territory: false,
    capital: "Santa Fe",
    contiguous: true,
  },
  {
    name: "New York",
    abbreviation: "NY",
    territory: false,
    capital: "Albany",
    contiguous: true,
  },
  {
    name: "North Carolina",
    abbreviation: "NC",
    territory: false,
    capital: "Raleigh",
    contiguous: true,
  },
  {
    name: "North Dakota",
    abbreviation: "ND",
    territory: false,
    capital: "Bismarck",
    contiguous: true,
  },
  {
    name: "Northern Mariana Islands",
    abbreviation: "MP",
    territory: true,
    capital: "Saipan",
    contiguous: false,
  },
  {
    name: "Ohio",
    abbreviation: "OH",
    territory: false,
    capital: "Columbus",
    contiguous: true,
  },
  {
    name: "Oklahoma",
    abbreviation: "OK",
    territory: false,
    capital: "Oklahoma City",
    contiguous: true,
  },
  {
    name: "Oregon",
    abbreviation: "OR",
    territory: false,
    capital: "Salem",
    contiguous: true,
  },
  {
    name: "Palau",
    abbreviation: "PW",
    territory: true,
    capital: "Ngerulmud",
    contiguous: false,
  },
  {
    name: "Pennsylvania",
    abbreviation: "PA",
    territory: false,
    capital: "Harrisburg",
    contiguous: true,
  },
  {
    name: "Puerto Rico",
    abbreviation: "PR",
    territory: true,
    capital: "San Juan",
    contiguous: false,
  },
  {
    name: "Rhode Island",
    abbreviation: "RI",
    territory: false,
    capital: "Providence",
    contiguous: true,
  },
  {
    name: "South Carolina",
    abbreviation: "SC",
    territory: false,
    capital: "Columbia",
    contiguous: true,
  },
  {
    name: "South Dakota",
    abbreviation: "SD",
    territory: false,
    capital: "Pierre",
    contiguous: true,
  },
  {
    name: "Tennessee",
    abbreviation: "TN",
    territory: false,
    capital: "Nashville",
    contiguous: true,
  },
  {
    name: "Texas",
    abbreviation: "TX",
    territory: false,
    capital: "Austin",
    contiguous: true,
  },
  {
    name: "Utah",
    abbreviation: "UT",
    territory: false,
    capital: "Salt Lake City",
    contiguous: true,
  },
  {
    name: "Vermont",
    abbreviation: "VT",
    territory: false,
    capital: "Montpelier",
    contiguous: true,
  },
  {
    name: "Virgin Islands",
    abbreviation: "VI",
    territory: true,
    capital: "Charlotte Amalie",
    contiguous: false,
  },
  {
    name: "Virginia",
    abbreviation: "VA",
    territory: false,
    capital: "Richmond",
    contiguous: true,
  },
  {
    name: "Washington",
    abbreviation: "WA",
    territory: false,
    capital: "Olympia",
    contiguous: true,
  },
  {
    name: "West Virginia",
    abbreviation: "WV",
    territory: false,
    capital: "Charleston",
    contiguous: true,
  },
  {
    name: "Wisconsin",
    abbreviation: "WI",
    territory: false,
    capital: "Madison",
    contiguous: true,
  },
  {
    name: "Wyoming",
    abbreviation: "WY",
    territory: false,
    capital: "Cheyenne",
    contiguous: true,
  },
];

export const create_links = [
  {
    title: "AI Design",
    description:
      "Inspire your ideas using text-to-image and image variation, enable you to conjure up fashionable attire from mere sketches and fabric swatches.",
    src: "https://upstyledus.oss-us-east-1.aliyuncs.com/www/videos/create-image-transformation.mp4",
    imgSrc:
      "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/tyIJqo2-cq0G5TGaDZ9OJ/create-fashion-lab.png",

    //link: "/create/ailab?tab=image-transformation",
    link: "/workspace/fashion-lab",
    icon: <CollectionsIcon fontSize="medium" color="inherit" />,
  },
  {
    title: "Moodboard",
    description: "Inspire Your Mood: Create with Images, Colors, Videos, and Songs!",
    src: "https://upstyledus.oss-us-east-1.aliyuncs.com/www/videos/create-moodboard.mov",
    imgSrc:
      "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/4P0CFEqcn_exROnhg-2ar/create-moodboard.jpeg",
    link: "/create/moodboard",
    icon: <PaletteIcon fontSize="medium" color="inherit" />,
  },
  // {
  //   title: "Style",
  //   description:
  //     "Easily organize, and manage all design information, including prices, colorways, sizes, and more.",
  //   src: "https://upstyledus.oss-us-east-1.aliyuncs.com/www/videos/create-style.mov",
  //   imgSrc:
  //     "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/4P0CFEqcn_exROnhg-2ar/create-style.jpeg",
  //   link: "/create/style",
  // },
  {
    title: "Tech Pack",
    description: "Factory-Ready Tech Packs: Simplify your Tech Pack creation process.",
    src: "https://upstyledus.oss-us-east-1.aliyuncs.com/www/videos/create-techpack.mov",
    imgSrc:
      "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/4P0CFEqcn_exROnhg-2ar/create-techpack.jpeg",
    link: "/create/tech-pack",
    icon: <DesignServicesIcon fontSize="medium" color="inherit" />,
  },
  {
    title: "Social Post",
    description:
      "Engage with your community: Share designs, launches, and updates with our social post feature.",
    src: "https://upstyledus.oss-us-east-1.aliyuncs.com/www/videos/create-post.mov",
    imgSrc:
      "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/4P0CFEqcn_exROnhg-2ar/create-post.jpeg",
    link: "/post/create",
    icon: <PhotoAlbumIcon fontSize="medium" color="inherit" />,
  },
];
